import React from "react";
import { Stack } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ProjectPackageSummaryVM } from "../../../../api/generated/models";
import { isNullOrUndefined } from "../../../../shared/utils/data.utils";
import { RootState } from "../../../../state-management/root-reducer";
import {
  setSelectedPackage,
  setIsPackageSelectorModalOpen,
} from "../../../../state-management/slices/packageSelector/package-selector.slice";
import { useAppDispatch } from "../../../../state-management/store";
import PACKAGE_ITEM from "../renderer/PackageItem.renderer";
import {
  IPackageListProps,
  DefaultPackageListProps,
} from "./PackageList.types";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import faker from "faker";
import {
  EPhaseNames,
  parsePhaseName,
} from "../../../../shared/enums/phases.enums";
import { ClickEvent } from "../../../../shared/types/event.types";

const PACKAGE_LIST: React.FC<IPackageListProps> = (
  props: IPackageListProps
) => {
  const { packageList } = props;

  const dispatch = useAppDispatch();
  const sendDataToGTM = useGTMDispatch();
  const history = useHistory();

  // APP STATE
  const { selectedPackage, isPackageSelectorModalOpen } = useSelector(
    (state: RootState) => state.packageSelector
  );

  return (
    <Stack data-testid="package-list-component">
      {packageList &&
        packageList.length &&
        packageList.map((packageItem: ProjectPackageSummaryVM) => {
          const isCompleted =
            parsePhaseName(packageItem?.phase?.id ?? "") ===
            EPhaseNames.COMPLETED;
          return (
            <PACKAGE_ITEM
              data-testid="package-list-item"
              key={`${packageItem.packageName ?? faker.datatype.uuid()}`}
              packageItem={packageItem}
              selected={
                !isNullOrUndefined(selectedPackage) &&
                selectedPackage.packageId === packageItem.packageId
                  ? true
                  : false
              }
              onClick={
                /* istanbul ignore next */ (event?: ClickEvent) => {
                  if (isCompleted) {
                    event?.preventDefault();
                    return;
                  }
                  dispatch(setSelectedPackage(packageItem));
                  history.push(
                    `${history.location.pathname}?packageId=${packageItem.packageId}`
                  );
                  sendDataToGTM({
                    event: "eventTracking",
                    category: "Construction",
                    action: "Click - Project Details",
                    label: `Package selected - Package Name: ${packageItem.packageName}`,
                  });

                  if (isPackageSelectorModalOpen) {
                    dispatch(setIsPackageSelectorModalOpen(false));
                  }
                }
              }
              disabled={isCompleted}
            />
          );
        })}
    </Stack>
  );
};

PACKAGE_LIST.defaultProps = DefaultPackageListProps;
export default PACKAGE_LIST;
